export default "__VITE_ASSET__b8002ed8__"